import React from 'react'
import { useNavigate } from 'react-router-dom'

export function BackButton({
  to,
  children,
  icon = null,
  onBeforeNavigate,
  className = 'back-button',
}) {
  const navigate = useNavigate()

  const handleClick = () => {
    onBeforeNavigate?.()
    navigate(to)
  }

  return (
    <div className="back-button-container">
      <button
        type="button"
        className={className}
        onClick={handleClick}
        title="back button"
      >
        {icon}
        {children}
      </button>
    </div>
  )
}
